/* @ngInject */
export default function AthenaRoutes(
  $stateProvider,
) {
  $stateProvider
    .state('mentoring-programs-abstract', {
      parent: 'institution-abstract',
      url: '/mentoring-programs',
      abstract: true,
      views: {
        'main@mainGridContent': {
          controller: 'MentoringProgramsCtrl',
          templateUrl: 'athena/templates/mentoring-programs.html',
        },
      },
      data: {
        headerClass: 'no-header',
      },
    })
    .state('mentoring-programs', {
      parent: 'mentoring-programs-abstract',
      url: '/',
    })
    .state('mentoring-program-wrapper', {
      abstract: true,
      url: [
        '/mentoring-programs/:programId',
        '?{showProfile:bool}',
        '&{authenticationView:int}',
        '&{showSession:int}',
        '&{guideId:int}',
        '&{tab:string}',
        '&{mentorRequest:int}',
        '&{source:int}',
        '&{mentorId:int}',
        '&{showBrowseMentors:bool}',
        '&{showLimitModal:bool}',
      ].join(''),
      parent: 'user-grid-abstract',
      views: {
        'main-panel@user-grid-abstract': {
          templateUrl: 'layouts/templates/main-content.html',
        },
      },
      data: {
        level: 1,
      },
    })
    .state('mentoring-program-abstract', {
      abstract: true,
      parent: 'mentoring-program-wrapper',
      views: {
        'main@mentoring-program-wrapper': {
          controller: 'MentoringProgramCtrl',
          templateUrl: 'athena/templates/mentoring-program.html',
        },
      },
      data: {
        headerClass: 'athena-header',
      },
    })
    .state('mentoring-program-root', {
      url: '/',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-single-connection', {
      url: '/connections/:connectionId?{sessionId:int}&{newSession:bool}&{showReflections:bool}',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-recruitment', {
      url: '/recruitment',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-participants', {
      url: '/participants',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-connections', {
      url: '/connections',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-guidance', {
      url: '/guidance',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-communications', {
      url: '/communications',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-reporting', {
      url: '/analytics',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-settings', {
      url: '/settings',
      parent: 'mentoring-program-abstract',
      abstract: true,
      data: {
        headerClass: 'no-header',
      },
    })
    .state('mentoring-program-program-setup-settings', {
      url: '/program-setup',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-recruitment-settings', {
      url: '/recruitment',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-profile-setup-settings', {
      url: '/profile-setup',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-matching-settings', {
      url: '/matching',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-guidance-settings', {
      url: '/guidance',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-feedback-settings', {
      url: '/feedback',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-program-wrap-up-settings', {
      url: '/program-wrap-up',
      parent: 'mentoring-program-settings',
    })
    .state('mentoring-program-my-mentees', {
      url: '/my-mentees',
      parent: 'mentoring-program-abstract',
    })
    .state('mentoring-program-flyer', {
      url: '/recruitments/:recruitmentId/join',
      parent: 'mentoring-program-abstract',
    });
}
